import { CodeBase } from "./_codeBase";

/**
 * 単純にフラグ
 */
export class EnableFlag extends CodeBase<EnableFlag>
{

    /** 有効フラグ: true, "有効" */
    public static readonly TRUE: EnableFlag = new EnableFlag(true, "有効", 'true');
    /** 有効フラグ: false, "無効" */
    public static readonly FALSE: EnableFlag = new EnableFlag(false, '無効', 'false');


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(code: any, value: string, abbr?: any) {
        super(code, value, abbr);
    }

    /**
     * 
     */
    public static List(): EnableFlag[] {
        return [EnableFlag.TRUE, EnableFlag.FALSE,];
    }
}
